import classnames from 'classnames';
import * as React from 'react';

import { Icon } from '@ao-internal/components-react';

interface ChatWindowHeaderProps extends React.HTMLProps<HTMLElement> {
	clickCloseCallback: (evt: React.MouseEvent) => void;
	showDivider?: boolean;
}

export const ChatWindowHeader: React.FC<ChatWindowHeaderProps> = ({
	clickCloseCallback,
	showDivider = true,
	children,
}) => {
	return (
		<div
			data-tag-area="window header"
			className={classnames('flex items-center p-4 bg-white z-40', {
				'border-0 border-b border-solid border-gray-30': showDivider,
			})}
		>
			<div className="flex items-center justify-center">
				<span
					className="ico ico-2x ico-ao-logo text-ongreen block"
					role="img"
					aria-label="AO Logo"
				></span>
			</div>
			<div className="pl-4">
				<p className="text-title text-primary mb-0 font-bold">{children}</p>
			</div>
			<div className="md:none pl-4 ml-auto">
				<button
					data-tag-name="close cta"
					data-testid="close-chatbot"
					type="button"
					aria-label="Close AO Assistant"
					onClick={clickCloseCallback}
					className="c-chat-window-header-close-cta bg-white cursor-pointer"
				>
					<span className="sr-only">Close AO Assistant</span>
					<Icon
						icon="close"
						className="text-cta-action"
						style={{ fontSize: '23px' }}
					/>
				</button>
			</div>
		</div>
	);
};

export default ChatWindowHeader;
